import React from 'react'
import StarRatings from 'react-star-ratings'
import { coachDemoImg, LocationIconDarkBlack } from '../../../../constant/imagePath'
import Colors from '../../../../stories/assets/Colors'
import Fonts from '../../../../stories/assets/Fonts'
import classes from './SearchResults.module.css'
import { Button } from '../../../../stories/Button/Button'
import { ReactSVG } from 'react-svg'

function SearchResultsPopup({
    data = { rating: 4, firstName: 'John', lastName: 'Johnson', sports: 'Tennic Coach', distance: '0.6 mi', address: 'Washington, DC' }
}) {
    return (
        <>
            <div className={classes.popup}>
                <div className={classes.content}>
                    <img src={coachDemoImg} className={classes.img} />
                    <div>
                        <h6 style={{ ...Fonts.h6, color: Colors.neutralShadesOfNero }}>{`${data?.firstName} ${data?.lastName}`}</h6>
                        <p className={classes.mb4} styl={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>{data?.sports}</p>
                        <div className={classes.rating}>
                            <StarRatings
                                starRatedColor={Colors.mainShadeOfRed}
                                starEmptyColor={Colors.neutralShadesOfDimGray}
                                rating={data?.rating / 5}
                                starDimension={"16px"}
                                numberOfStars={1}
                            />
                            <span className={classes.ml4} style={{ ...Fonts.h9, color: Colors.neutralShadesOfNero }}>{data?.rating}</span>

                        </div>
                        <div className={classes.location}>
                            <span style={{ ...Fonts.h9, color: Colors.neutralShadesOfNero }}>
                                <ReactSVG src={LocationIconDarkBlack} beforeInjection={(svg) => svg.classList.add(classes.locIcon)} />
                                {data?.address}</span>
                            <span className={classes.dot} style={{ background: Colors.neutralShadesOfDimGray }} />
                            <span style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}>{data?.distance} away</span>
                        </div>

                    </div>
                </div>
                <Button size={'Large'}>
                    <span style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>Next available</span>:<span style={{ ...Fonts.h9, color: Colors.neutralShadesOfNero }}>Today</span>
                </Button>
            </div>
        </>
    )
}

export default SearchResultsPopup